export default {
  async setLocale({ commit }, payload) {
    return commit('SET_LOCALE', payload)
  },

  async setLocales({ commit }, payload) {
    return commit('SET_LOCALES', payload)
  },
}
